import React from 'react';

const FormMessage = ({children}) => {
    return (
        <section className="form-message animated fadeIn go">
            <div className="form-message__content">
                <div className="form-message__success-message !flex-col !items-center">
                    <img src="/images/icons/other/icon_checklist-white.svg" alt="Ikona" />
                    {children}
                </div>
            </div>
        </section>
    );
};

export default FormMessage;